<script lang="ts" setup>
import ConditionLink from '@/home/components/ConditionLink.vue';

const props = defineProps({
  title: {
    type: String,
    default: '',
  },
  link: {
    type: String,
    default: '',
  },
});
</script>

<template>
  <section class="certification-card rounded-4 bg-white shadow-[0_0_16px_0_rgba(0,0,0,0.04)]">
    <ConditionLink :href="props.link" target="_blank" class="text-inherit no-underline">
      <div class="title h-80 flex items-center rounded-t-4">
        <h3 class="m-0 ml-31 mr-170 truncate text-24 text-#2d2d2d font-normal leading-48">
          {{ props.title }}
        </h3>
      </div>

      <div class="detail px-32 py-24">
        <slot></slot>
      </div>
    </ConditionLink>
  </section>
</template>

<style lang="scss" scoped>
.certification-card {
  * {
    box-sizing: border-box;
  }

  &:nth-child(3n+1) {
    .title {
      background-image: url(@/home/assets/certification/theme-1.png), linear-gradient(270deg, #50a2ff 0, #d8eaff 100%);
    }

    .detail::v-deep() {
      .heading-4 {
        @apply text-#0078FF;

        .number {
          @apply bg-[rgba(0,120,255,0.1)];
        }
      }
    }
  }

  &:nth-child(3n+2) {
    .title {
      background-image: url(@/home/assets/certification/theme-2.png), linear-gradient(-90deg, #9599ff 0, #c6d1ff 100%);
    }

    .detail::v-deep() {
      .heading-4 {
        @apply text-#2B00FF;

        .number {
          @apply bg-[rgba(43,0,255,0.1)];
        }
      }
    }
  }

  &:nth-child(3n+3) {
    .title {
      background-image: url(@/home/assets/certification/theme-3.png), linear-gradient(-90deg, #ffd395 0, #ffe7c6 100%);
    }

    .detail::v-deep() {
      .heading-4 {
        @apply text-#F08C00;

        .number {
          @apply bg-[rgba(240,140,0,0.1)];
        }
      }
    }
  }

  .title {
    background-repeat: no-repeat;
    background-position: right 32px bottom, center;
    background-size: 120px 68px, contain;
  }

  .detail::v-deep() {
    p {
      color: #3d3d3d;
      font-size: 16px;
      line-height: 24px;

      &:first-child {
        margin-top: 0;
      }

      &:last-child {
        margin-bottom: 0;
      }
    }

    .heading-4 {
      @apply m-0 flex items-center gap-x-16;

      .number {
        @apply rounded-4 px-8 py-2 text-14 font-medium leading-20;
      }

      .text {
        @apply text-16 font-medium leading-24;
      }

      .link {
        @apply text-16 text-inherit font-normal leading-24;
      }
    }
  }
}
</style>
